import { useRef } from "react";

export function useDebouncedSearch(callback: (value: string) => void, delay = 300) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleChange = (value: string | null | undefined) => {
    let _value = "";
    if (value?.length) {
      _value = value;
    }
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      callback(_value);
    }, delay);
  };

  return handleChange;
}
